export default __webpack_public_path__ + "static/media/hildabroom-banner.e2c2aaff.png";